import type { Task } from "@common/types/task";
import type { TaskBoardTask } from "./types";

const tasksWithUnreadCount = new WeakMap<Task, TaskBoardTask>();

/**
 * Returns the same object while the task and its unread count are unchanged,
 * so a refetch or a mark-read doesn't re-render every memoized list row.
 */
export const withUnreadCount = (
    task: Task,
    unreadCount: number,
): TaskBoardTask => {
    const cached = tasksWithUnreadCount.get(task);
    if (cached?.unreadCount === unreadCount) {
        return cached;
    }
    const taskWithUnreadCount = { ...task, unreadCount };
    tasksWithUnreadCount.set(task, taskWithUnreadCount);
    return taskWithUnreadCount;
};
